import { render, staticRenderFns } from "./StudyingCertificatehigh.vue?vue&type=template&id=8830d5f0&"
import script from "./studyingcertificatehigh.js?vue&type=script&lang=js&"
export * from "./studyingcertificatehigh.js?vue&type=script&lang=js&"
import style0 from "./StudyingCertificatehigh.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports